/* CC Model Required — cached logic (loaded once, reused site-wide)
   Requires <cc-model-required data-form-id="..."> in the DOM.
   Forces an active model choice before ATC / GoKwik Buy Now. Never touches GoKwik
   (capture-phase intercept only). Fails open if sessionStorage is unavailable. */
(function(){
  if (window.__ccModelRequiredLoaded) return;   // guard against double-include (buy-buttons renders twice)
  window.__ccModelRequiredLoaded = true;

  function init(root){
    if(root.__ccMrInit) return; root.__ccMrInit = true;

    var formId = root.dataset.formId;
    var form   = document.getElementById(formId);
    if(form && form.__ccMrGated) return;          // a sibling element already gated this form

    // locate the sibling-product MODEL dropdown; bail on any PDP that doesn't have one
    var picker = document.querySelector('.product-info__product-picker');
    var sel;
    if(picker){
      sel = picker.querySelector('select');
      if(!sel) return;
      var legend = picker.querySelector('legend');
      if(!(legend && /model/i.test(legend.textContent || ''))) return;
    } else {
      /* cc 2026-08-28: on Luma PDPs the HB setup selector replaces the product_variations
         block, so .product-info__product-picker does not exist and this gate used to bail
         out entirely — ATC and GoKwik Buy Now fired with no model chosen. Its Step 2
         dropdown is the same sibling-navigation model picker; gate on that instead. */
      sel = document.querySelector('select[data-hbss-model]');
      if(!sel) return;
      picker = sel.closest('.hbss__step') || sel.parentElement;
      if(!picker) return;
    }

    // FAIL OPEN: never risk trapping a shopper who can't persist their choice across page nav
    try { sessionStorage.setItem('cc_mr_t','1'); sessionStorage.removeItem('cc_mr_t'); }
    catch(e){ return; }

    if(form) form.__ccMrGated = true;
    root.hidden = false;
    var body  = document.body;
    var toast = root.querySelector('[data-cc-mr-toast]');
    var toastTimer;

    function chosen(){ try { return sessionStorage.getItem('cc_model_chosen') === '1'; } catch(e){ return false; } }
    function mark(){ try { sessionStorage.setItem('cc_model_chosen', '1'); } catch(e){} }

    function lock(){
      body.classList.add('cc-mr-locked');
      if(!sel.querySelector('option[data-cc-mr]')){
        var o = document.createElement('option');
        o.value = ''; o.textContent = 'Select your model'; o.setAttribute('data-cc-mr','');
        sel.insertBefore(o, sel.firstChild);
      }
      sel.value = '';
    }
    function unlock(){
      body.classList.remove('cc-mr-locked');
      var o = sel.querySelector('option[data-cc-mr]'); if(o) o.remove();
    }

    /* cc 2026-08-28: also UNLOCK here. The old product_variations picker navigated on every
       change, and the reload re-ran init() which unlocked. The setup selector deliberately
       does NOT navigate when you pick the model you are already on, so without this the page
       stayed visually locked even after a valid choice. */
    sel.addEventListener('change', function(){ if(sel.value){ mark(); unlock(); } });

    /* cc 2026-08-28: the setup selector rebuilds its <option> list on every brand-pill click
       (modelSel.innerHTML = ''), which wipes the placeholder lock() inserted. It calls this
       hook after each rebuild so the lock can re-assert itself. Order-independent: whichever
       of the two scripts runs second still ends up locked. */
    window.__ccMrRelock = function(){ if(!chosen()) lock(); };

    /* cc 2026-09-17 (Dipesh): __ccMrRelock can only ever LOCK a gate that was never
       answered, so a brand pill that rebuilds the model list for the OTHER brand left the
       page showing "Select your model" over a list that does not belong to this product
       while the gate still said "answered" - ATC added the iPhone case under a Samsung
       list. This hook sets the answer in BOTH directions. Additive: nothing else on the
       site calls it, so every other PDP behaves byte-identically.
       true  => this list belongs to the product on screen and the model is answered
       false => un-answer it and lock, exactly like a fresh landing. */
    window.__ccMrSync = function(isAnswered){
      if(isAnswered){ mark(); unlock(); }
      else { try { sessionStorage.removeItem('cc_model_chosen'); } catch(e){} lock(); }
    };

    /* cc 2026-08-30 (Dipesh): the nudge must point at the step that is ACTUALLY blocking, not
       always at the model picker. A page may expose window.__ccMrNudgeTarget() returning
       { el, focus, text } to redirect it — the Luma setup selector uses this to pulse
       "Step 1: Select Brand" while no brand has been picked, then lets it fall through to the
       model picker once one has. No hook => byte-identical behaviour on every other PDP. */
    var toastText    = root.querySelector('[data-cc-mr-toast-text]');
    var toastDefault = toastText ? toastText.textContent : null;

    function nudgeTarget(){
      try {
        if(typeof window.__ccMrNudgeTarget === 'function'){
          var t = window.__ccMrNudgeTarget();
          if(t && t.el) return t;
        }
      } catch(e){}
      return { el: picker, focus: true };
    }

    function nudge(){
      var t = nudgeTarget(), el = t.el;
      el.scrollIntoView({ behavior:'smooth', block:'center' });
      el.classList.remove('cc-mr-pulse'); void el.offsetWidth; el.classList.add('cc-mr-pulse');
      setTimeout(function(){ el.classList.remove('cc-mr-pulse'); }, 1400);
      /* focusing the model <select> while we are asking for a BRAND would fight the pulse.
         cc 2026-10-03 (Dipesh): on a phone, focus() on a native <select> inside a tap OPENS the model list —
         he wants the page to just scroll to the picker. Focus only where a pointer can hover (desktop). */
      var canHover = false; try { canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch(e){}
      if(t.focus !== false && canHover){ try { sel.focus(); } catch(e){} }
      if(toastText) toastText.textContent = t.text || toastDefault;
      if(toast){ toast.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(function(){ toast.hidden = true; }, 2600); }
    }

    if(form){
      form.addEventListener('submit', function(e){            // main ATC + sticky-bar ATC (form attr)
        if(chosen()) return;
        e.preventDefault(); e.stopImmediatePropagation(); nudge();
      }, true);
      form.addEventListener('click', function(e){             // GoKwik Buy Now + ATC click inside the form
        if(chosen()) return;
        var btn = e.target.closest('button[type="submit"], #gokwik-buy-now');
        if(!btn) return;
        e.preventDefault(); e.stopImmediatePropagation(); nudge();
      }, true);
    }

    /* cc 2026-07-04: sold-out PDPs render ATC as <button disabled>Sold out</button>,
       and browsers swallow every click on a disabled button — so the nudge above
       never fires and the button just feels dead. Re-arm those buttons: same
       sold-out look (aria-disabled + CSS), clickable purely to nudge the model
       picker toward an in-stock model. They can never add to cart — the capture
       handler below always intercepts, and re-disables once a model is chosen. */
    if(!chosen()){
      var armed = false;
      document.querySelectorAll('button[type="submit"][disabled]').forEach(function(b){
        var bb = b.closest('buy-buttons');
        var ownerForm = b.getAttribute('form') || (bb && bb.getAttribute('form')) || (b.closest('form') || {}).id;
        if(ownerForm !== formId) return;
        b.disabled = false;
        b.setAttribute('aria-disabled','true');
        b.setAttribute('data-cc-mr-soldout','');
        armed = true;
      });
      if(armed && !window.__ccMrSoldOutHandler){
        window.__ccMrSoldOutHandler = true;
        document.addEventListener('click', function(e){
          var btn = e.target.closest('[data-cc-mr-soldout]');
          if(!btn) return;
          e.preventDefault(); e.stopImmediatePropagation();
          if(chosen()){ btn.disabled = true; btn.removeAttribute('data-cc-mr-soldout'); return; }
          nudge();
        }, true);
      }
    }

    if(chosen()) unlock(); else lock();
  }
  function boot(){ document.querySelectorAll('cc-model-required').forEach(init); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
